import { render, staticRenderFns } from "./sso-configuration-layout.vue?vue&type=template&id=ac4f12d2"
import script from "./sso-configuration-layout.vue?vue&type=script&lang=js"
export * from "./sso-configuration-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports